import React from 'react';

import './UserStravaSynchronization.css';
import stravaLogo from 'static/img/strava-logo.svg';
import stravaSynchronise from 'static/img/strava-synchronise.svg';
import stravaTick from 'static/img/strava-tick.svg';

const UserStravaSynchronization = (props) => {
    const disconnectStrava = (e) => {
      e.preventDefault();
      props.disconnectStrava();
    }

    const StravaSynchronised = () => {
      return(
        <React.Fragment>
          <img className="UserStravaSynchronization-tick" src={stravaTick} alt="" />
          <p className="UserStravaSynchronization-text">Your account is connected.</p>
          <a className="UserStravaSynchronization-disconnect" href="" onClick={disconnectStrava}>
            Disconnect
          </a>
        </React.Fragment>
      )
    }
    const StravaUnsynchronised = () => {
      return(
        <React.Fragment>
          <p className="UserStravaSynchronization-text">Connect your Strava account and import your activities here.</p>
          <a className="UserStravaSynchronization-synchronise" href={process.env.REACT_APP_STRAVA_START_SYNC_URL}>
            <img src={stravaSynchronise} alt="" /><span>Connect</span>
          </a>
        </React.Fragment>
      )
    }

    const showStravaSynchronizationContent = (isSynchronised) => {
      switch(isSynchronised){
        case false:
          return <StravaUnsynchronised />;
        case true:
          return <StravaSynchronised />;
        default:
          return null;
      }
    }

    return (
        <div className="UserStravaSynchronization">
          <img className="UserStravaSynchronization-logo" src={stravaLogo} alt="Strava" />
          {showStravaSynchronizationContent(props.stravaConnection)}
        </div>
    );
}
export default UserStravaSynchronization;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/UserStravaSynchronization/UserStravaSynchronization.js